var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.451c.887 0 1.607-.72 1.607-1.61 0-.889-.72-1.61-1.607-1.61s-1.607.721-1.607 1.61c0 .89.72 1.61 1.607 1.61Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 2.625A2.623 2.623 0 0 1 6.22 0h11.56a2.623 2.623 0 0 1 2.62 2.625v18.75A2.623 2.623 0 0 1 17.78 24H6.22a2.623 2.623 0 0 1-2.62-2.625V2.625Zm2.62-.375a.375.375 0 0 0-.374.375v18.75c0 .207.168.375.374.375h11.56a.375.375 0 0 0 .374-.375V2.625a.375.375 0 0 0-.375-.375H6.22Z",
    fill: "currentColor"
  })));
};
export default SvgMobile;